<template>
    <div class="card-method-box">
        <div class="img-box">
            <img class="icon-img" :src="imgSrc">
        </div>
    </div>
</template>

<script setup>
    import {getCurrentInstance, computed} from "vue";

    const props = defineProps(["url"])

    const { proxy } = getCurrentInstance()
    const publicPath = process.env.BASE_URL

    const imgSrc = computed(() => {
        let url = `${publicPath}static/images/empty.jpg`

        if (null != props.url){
            url = proxy.$ShopopeeUrl + props.url
        }

        return url
    })

</script>

<style scoped>
    .card-method-box {
        width: 100%;
        box-sizing: border-box;
        padding: 10px;
    }

    .card-method-box .img-box {
        width: 100%;
        padding-top: 100%;
        position: relative;
        transition: all 0.3s ease;
    }

    .card-method-box .img-box:hover {
        transform: scale(1.1);
    }

    .card-method-box .icon-img {
        border: 1px solid #EFEFEF;
        border-radius: 10px;
        height: 100%;
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
        user-select: none;
        cursor: pointer;
    }
</style>